import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import LanguageBar from "../../locales/LanguageBar";
import ScreenSizeBar from "../../components/user/ScreenSizeBar";
import bgImage from "../../assets/images/green-level.jpg";
import missionImage from "../../assets/images/e-receipt.png";
import bigPointIcon from "../../assets/images/coin-icon.png";
import userIcon from "../../assets/images/user-icon.png";
import bigcImg from "../../assets/images/big-c.jpg";
import BigpointCard from "../../assets/images/bigpoint-card.db944bd.png";
import ScanIcon from "../../assets/images/scan-icon.png";
import axios from "axios";
import BigpointDealCard from "./BigpointDealCard";
import { useLiffProfile } from "../../context/LiffProfileContext";
import LoadingBar from "../LoadingBar";
import { Link } from "react-router-dom";
import getfile from "../../utils/getFile";
import MissionsCard from "../missions/missionsCard";
import { MaskInputHelper } from "../helpers/mask-input-helper";

// 👉 เพิ่มการ import data
//import missionsData from "./mission.json"; // <<< important line

// Reusable component for displaying point or game data
const DataCard = ({ title, value, icon, footerText }) => (
  <div className="w-full p-2 flex flex-col justify-between bg-secondary-text-invert rounded-2xl bg-white">
    <div className="w-full flex items-center text-primary-text gap-1.5">
      <img src={icon} alt="Point Icon" className="w-8 h-8" />
      <div>{title}</div>
    </div>
    <div className="w-full pb-2 pr-3 xs:pr-1 text-32 font-semibold text-right">
      {value ?? "0"}
    </div>
    {footerText && <div>{footerText}</div>}
  </div>
);

const MyBigpoint = () => {
  const { t, i18n } = useTranslation();
  const { authToken, userId, profile } = useLiffProfile();
  const [data, setData] = useState({
    point: 0,
    totalGamePoint: 0,
    bigCardNumber: "",
    pointExpire: 0,
    missionGroups: [],
    hotDealGroups: [],
    userData: null,
    pointData: null,
  });
  const [pointExpireData, setPointExpireData] = useState(null); // <-- เพิ่มตรงนี้
  const [loading, setLoading] = useState(true);
  const [imageUrls, setImageUrls] = useState({});
  const [imageMissionUrls, setImageMissionUrls] = useState({});

  const [seniorLayout, setSeniorLayout] = useState(() => {
    const savedLayout = localStorage.getItem("seniorLayout");
    return savedLayout === "true"; // ถ้าได้ "true" (string) ก็คืน true, ถ้าไม่มีหรือไม่ตรงก็ false
  });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const clientAuth = process.env.REACT_APP_CLIENT_AUTH;
        const headers = {
          Authorization: `Bearer ${authToken}`,
          "X-Client-Auth": clientAuth,
          "x-user-id": userId,
          "Accept-Language": i18n.language.toUpperCase(),
        };

        const userResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/users/current`,
          { headers }
        );
        const pointResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/users/current/clm-point`,
          { headers }
        );
        const hotDealResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/clm-coupons?hotDeals=true`,
          { headers }
        );
        const missionResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/clm-missions?started=true&completed=false&orderBy=priority%3AASC`,
          { headers }
        );

        const pointExpireResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/users/current/clm-point-expire`,
          { headers }
        );

        setData({
          userData: userResponse.data?.data,
          pointData: pointResponse.data?.data,
          missionGroups: missionResponse.data?.data?.items || [],
          point: pointResponse.data?.data?.pointBalance || 0,
          totalGamePoint: userResponse.data?.data?.totalGamePoint || 0,
          hotDealGroups: hotDealResponse.data?.data?.items || [],
          bigCardNumber: userResponse.data?.data?.bigCardNumber || "",
        });
        setPointExpireData(pointExpireResponse.data?.data); // <-- และเก็บ data

        hotDealResponse.data.data.items.forEach((item) => {
          if (item.thumbnail) {
            getfile(item.thumbnail, authToken, userId)
              .then((url) => {
                setImageUrls((prevUrls) => ({
                  ...prevUrls,
                  [item.id]: url || bigcImg,
                }));
              })
              .catch((err) => {
                console.error("Error fetching image:", err);
                setImageUrls((prevUrls) => ({
                  ...prevUrls,
                  [item.id]: bigcImg,
                }));
              });
          }
        });

        /*setData((prev) => ({
          ...prev,
          missionGroups: missionsData.data.items || [],
        }));
        const imagePromises = missionsData.data.items.map((item) => {
          */
        const imagePromises = missionResponse.data.data.items.map((item) => {
          if (item.image) {
            return getfile(item.image, authToken, userId).then((url) => ({
              id: item.id,
              url,
            }));
          }
          return Promise.resolve(null);
        });

        Promise.all(imagePromises).then((results) => {
          const imageMap = {};
          results.forEach((result) => {
            if (result) {
              imageMap[result.id] = result.url;
            }
          });
          setImageMissionUrls(imageMap);
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [authToken, userId, i18n.language]);

  const truncateText = (text, limit) => {
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString(
      i18n.language || "en-US",
      options
    );
  };

  //// mission
  const activeMissions = Array.isArray(data.missionGroups)
    ? data.missionGroups.filter(
        (item) => item.progressValue > 0 && item.status === "A"
      )
    : [];
  const groupedByCategory = activeMissions.reduce((acc, item) => {
    if (!acc[item.category]) {
      acc[item.category] = [];
    }
    acc[item.category].push(item);
    return acc;
  }, {});

  const latestItemsByCategory = Object.keys(groupedByCategory)
    .map((category) => {
      const validMissions = groupedByCategory[category].filter(
        (item) => !item.isCompleted && item.progressValue < item.completeValue
      );
      return validMissions.length > 0
        ? validMissions[validMissions.length - 1]
        : null;
    })
    .filter((item) => item !== null);

  return (
    <div className="min-h-screen w-full flex flex-col bg-gray-100">
      <div className="flex-grow overflow-y-auto">
        <div
          className="w-full py-3 flex flex-col justify-end bg-cover min-h-[200px] h-auto gap-2"
          style={{ backgroundImage: `url(${bgImage})` }}
        >
          <div className="flex items-center gap-3 px-5">
            <a href="/my-bigpoint">
              <img
                src={(profile && profile.pictureUrl) || userIcon}
                alt="User Profile"
                className="w-14 h-14 rounded-full"
              />
            </a>

            <div className="flex flex-col font-medium text-secondary-text-invert">
              <div className="text-base text-left">{data.bigCardNumber}</div>
              <div className="text-xl line-clamp-1 text-left">
                {profile && profile.displayName}
              </div>
            </div>
            <div className="ml-auto flex items-center gap-2">
              <a
                href="/my-bigpoint/history"
                aria-label={t("point_history")}
                className="w-9 h-9 flex justify-center items-center bg-white bg-opacity-50 rounded-full cursor-pointer"
              >
                <svg
                  className="w-5 h-5 text-primary-text"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="9" />
                  <polyline points="12 7 12 12 15 14" />
                </svg>
              </a>
              <div className="w-16 h-9 flex justify-center items-center bg-white bg-opacity-50 rounded-full cursor-pointer">
                <a href="/my-bigpoint/scan">
                  <img src={ScanIcon} alt={t("scan")} className="w-6 h-6" />
                </a>
              </div>
            </div>
          </div>

          <div className="h-full flex flex-col text-secondary-text-invert font-medium pt-2 gap-2">
            {/* กลุ่มแถวรูป + Member */}
            <div className="relative w-full flex items-center xs:pr-2 px-5">
              {/* รูปทางซ้าย */}
              <div className=" flex items-center z-10">
                <img
                  src={BigpointCard}
                  className="max-w-[60%] md:max-w-[270px] h-auto object-contain"
                  alt={t("profile_card")}
                />
              </div>

              {/* ข้อความ Member ทางขวา */}
              <div className="ml-auto flex items-center pr-5 z-10">
                <div className={`${seniorLayout ? "text-2xl" : "text-xl"}`}>
                  {t("Member")}
                </div>
              </div>
              {/* พื้นหลัง bg-primary เต็มแถว แต่ต่ำกว่ารูป */}
              <div className="absolute top-1/2 left-0 w-full translate-y-[-50%] bg-primary h-10" />
            </div>
          </div>
        </div>

        {/* Language & Screen Size Bar */}
        <div className="w-full flex px-5 py-2 bg-secondary-background items-center justify-between">
          <div className="flex items-center gap-x-3">
            <span
              className={`font-medium ${
                seniorLayout ? "text-xl" : "text-base"
              }`}
            >
              {t("language")}:
            </span>
            <LanguageBar className="w-26 h-9 p-1 rounded-full bg-secondary-background-gray-dark text-secondary-text-gray-light" />
          </div>
          <div className="flex items-center gap-x-3">
            <span
              className={`font-medium ${
                seniorLayout ? "text-xl" : "text-base"
              }`}
            >
              {t("screen_size")}:
            </span>
            <ScreenSizeBar
              className="bg-secondary-background-gray-dark text-secondary-text-gray-light"
              seniorLayout={seniorLayout}
              onChangeSeniorLayout={(value) => setSeniorLayout(value)}
            />
          </div>
        </div>

        {/* Data Cards */}
        <div className="w-full flex flex-col px-5 py-3 bg-gray-100">
          <div
            className={`w-full my-2 grid grid-cols-1 sm:grid-cols-2 gap-3 ${
              seniorLayout ? "text-xl" : "text-base"
            }`}
          >
            <DataCard
              title={t("my_big_point")}
              value={MaskInputHelper.formatNumber(
                data.pointData?.pointBalance || 0
              )}
              icon={bigPointIcon}
            />
            <DataCard
              title={t("big_game_gems")}
              value={MaskInputHelper.formatNumber(
                data.userData?.totalGamePoint || 0
              )}
              icon={bigPointIcon}
            />
          </div>

          <div
            className={`w-full border-l-[0.1875rem] border-[#da0010] my-2 flex items-center gap-4 font-medium pl-4 ${
              seniorLayout ? "text-xl" : "text-base"
            }`}
          >
            <div className="text-left">
              <div className="text-danger">
                <span>
                  {MaskInputHelper.formatNumber(
                    pointExpireData?.pointAmount ?? 0
                  )}
                </span>
                <span> {t("point")} </span>
                <span>
                  {t("expired")} {t("day")}{" "}
                  {pointExpireData
                    ? formatDate(pointExpireData.expireDate)
                    : ""}
                </span>
              </div>
            </div>
          </div>

          {/* Active Missions */}
          {latestItemsByCategory.length > 0 ? (
            <div className="w-full pt-3">
              <div
                className={`font-semibold text-left ${
                  seniorLayout ? "text-xl" : "text-base"
                }`}
              >
                {t("mission_status_label_active")}
              </div>
              <div className="w-full py-3">
                {latestItemsByCategory.map((item) => {
                  const isExpiredMission =
                    (item.dayToExpire || 0) <= 0 || item.status === "E";

                  const missionsInCategory = groupedByCategory[
                    item.category
                  ] || [item];

                  const actionLink =
                    missionsInCategory.length > 1
                      ? `/missions/${item.category}`
                      : `/missions/detail/${item.id}`;

                  return (
                    <MissionsCard
                      key={item.id}
                      item={item}
                      missionsInCategory={missionsInCategory}
                      imageUrls={imageMissionUrls} // ถ้าอยากได้รูปเพิ่ม ค่อยมาแก้
                      isExpiredMission={isExpiredMission}
                      templateDetail={false}
                      actionLink={actionLink}
                      showDescription={false}
                    />
                  );
                })}
              </div>

              <button
                className={`w-full text-base font-normal my-4 text-primary-text rounded-lg bg-[#e3edd4] p-5 ${
                  seniorLayout ? "text-xl" : "text-base"
                }`}
              >
                <a href="/missions">{t("see_more")}</a>
              </button>
            </div>
          ) : (
            ""
          )}

          {/* Hotdeal Card */}
          {data.hotDealGroups.length > 0 && (
            <div className="w-full pt-3">
              <div
                className={`font-semibold text-left ${
                  seniorLayout ? "text-xl" : "text-base"
                }`}
              >
                {t("hot_deals_for_you")}
              </div>
              <div className="w-full py-3">
                {data.hotDealGroups
                  .filter((item) => item.categoryCode === "01")
                  .map((item) => (
                    <div
                      key={item.id}
                      className="w-full rounded-2xl overflow-hidden min-h-[9rem] cursor-pointer border border-overlay-12 bg-white mb-3"
                    >
                      <div className="relative w-full h-full flex bg-grey-200 p-2">
                        <div className="w-full flex flex-col justify-between pl-2 pt-2 pr-2">
                          <div className="w-full flex gap-x-3 ">
                            <div className="relative flex justify-center items-center w-[30%] bg-secondary-background-gray">
                              <div className="relative rounded-xl overflow-hidden w-28 h-28 ">
                                <img
                                  src={
                                    imageUrls[item.id]
                                      ? imageUrls[item.id]
                                      : bigcImg
                                  }
                                  alt="Coupon"
                                  className="w-full h-full object-cover"
                                  onError={(e) => (e.target.src = bigcImg)}
                                />
                              </div>
                            </div>
                            <div className="text-20 text-left">
                              <div
                                className={`font-semibold line-clamp-2 ${
                                  seniorLayout ? "text-xl" : "text-base"
                                }`}
                              >
                                {item.name}
                              </div>
                              <div
                                className={`font-normal break-words line-clamp-3 ${
                                  seniorLayout ? "text-lg" : "text-sm"
                                }`}
                              >
                                {truncateText(item.tag?.join(" ") || "", 100)}
                              </div>
                            </div>
                            <Link
                              to={`/bcoupon_detail/${item.id}`}
                              className="absolute top-0 left-0 right-0 bottom-0 w-full h-full"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
              <button
                className={`w-full font-normal my-4 text-primary-text rounded-lg bg-[#e3edd4] p-5 ${
                  seniorLayout ? "text-xl" : "text-base"
                }`}
              >
                <a href="/bc-coupons?category=hot_deals">{t("see_more")}</a>
              </button>
            </div>
          )}
        </div>
      </div>

      {/* <<< Loading Popup ตรงนี้!! >>> */}
      <LoadingBar loading={loading} label="Loading..." />
    </div>
  );
};

export default MyBigpoint;
